export default __webpack_public_path__ + "static/media/no-hotel.c6e2ff07.png";